import ImgTag from "@/components/Helpers/ImgTag";
import PriceV2 from "@/components/Helpers/product-card/PriceV2";
import { validateImgSrc } from "@/utils/global";
import React from "react";

const Info = ({ item, price, loading }) => {
  return (
    <div className="flex me-2">
      <div className="relative w-32 h-24 border rounded-xl">
        <span className="absolute flex items-center justify-center p-1 text-xs font-bold leading-none rounded-md bg-slate-200 top-2 start-2 size-6">
          { item?.qty || 1}
        </span>

        <ImgTag
          src={validateImgSrc(
            item?.image ||
              `${process.env.NEXT_PUBLIC_IMAGE_BASEURL}/media/catalog/product/${item?.extension_attributes?.product_image}`
          )}
          className="object-contain p-1 size-full"
          height={100}
          width={100}
          alt="Prod Cart Img!"
        />
      </div>

      <div className="flex flex-col justify-between w-full mx-2">
        <p className="mb-1 font-semibold text-black text-[15px]">
          {item?.name || "product"}
        </p>

        {loading ? (
          <span className="inline-block h-5 w-20 rounded bg-gray-200 animate-pulse" />
        ) : (
          <PriceV2
            {...{
              discount: price?.discount,
              originalPrice: price?.originalPrice,
              specialPrice: price?.specialPrice,
              fromProductCard: false,
            }}
          />
        )}
        {/* {item?.back_orders && (
      <div className="text-[10px] w-fit font-semibold px-2 py-1 text-white bg-blue rounded-full text-center">
        {t("PreOrder")}
      </div>
    )} */}
      </div>
    </div>
  );
};

export default Info;
